import React from 'react'
import Image from '~/components/atoms/Image'
import FadeInWhenVisible from '~/components/FadeInWhenVisible'
import { BoldTailHeading } from '~/utils/boldTailHeading'
import './UspsAmenities.css'

export default function UspsAmenities({ section, index, className = '' }) {
  const { usps, textCard } = section
  const heading = textCard?.heading?.text
  // The Figma design has no eyebrow/label — the CMS "subheading" field
  // ("Property Amenities") isn't part of this design, "content" holds the
  // real subtitle copy shown under the heading.
  const subheading = textCard?.content

  if (!usps || !usps.length) {
    return null
  }

  return (
    <section id={section.fieldGroupName + index} className={`usps-amenities ${className}`}>
      <div className="container">
        {(heading || subheading) && (
          <div className="usps-amenities__header">
            {heading && (
              <h2 className="usps-amenities__heading">
                <BoldTailHeading text={heading} />
              </h2>
            )}
            {subheading && (
              <div className="usps-amenities__subheading" dangerouslySetInnerHTML={{ __html: subheading }} />
            )}
          </div>
        )}

        <div className="usps-amenities__row">
          {usps.map((usp, i) => (
            <FadeInWhenVisible key={`amenities${i}`} transition={{ delay: `${i * 0.05}` }} className="usps-amenities__card">
              {usp.image && (
                <div className="usps-amenities__card-media">
                  <Image data={usp.image} className="usps-amenities__card-image" objectFit="cover" />
                </div>
              )}
              <div className="usps-amenities__card-body">
                {usp.heading && <h3 className="usps-amenities__card-title">{usp.heading}</h3>}
                {usp.content && <p className="usps-amenities__card-content">{usp.content}</p>}
              </div>
            </FadeInWhenVisible>
          ))}
        </div>
      </div>
    </section>
  )
}
